module.exports = __webpack_public_path__ + "img/laravel-fullstack-app3.b2c292f4.png";